<template>
  <div class="dataset-card-list-box">
    <div class="filter-box">
      <div class="select-box">
        <el-select
          class="primary-select"
          popper-class="primary-select-custom primary-select-absolute"
          ref="treeSelect"
          size="small"
          :popper-append-to-body="false"
          :value="selectedNode.nodeName">
          <el-option
            class="primary-select-option"
            value="">
            <div class="common-tree-box">
              <el-tree
                class="dialog-tree-primary"
                ref="searchTree"
                :data="catalogTreeData"
                :props="defaultProps"
                node-key="nodeId"
                highlight-current
                :expand-on-click-node="false"
                @node-click="handleNodeClick">
                <div
                  slot-scope="{ data }"
                  class="custom-node-box">
                  <div class="node-label-box">
                    <div
                      class="node-label text-overflow"
                      :title="data.nodeName">
                      <span>{{ data.nodeName }}</span>
                    </div>
                  </div>
                </div>
              </el-tree>
            </div>
          </el-option>
        </el-select>
      </div>
      <div class="common-input-box">
        <el-input
          class="input-primary"
          size="small"
          v-model="keywords"
          placeholder="请输入文件名称"
          clearable
          @clear="search"
          @keyup.enter.native="search">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="search" />
        </el-input>
      </div>
      <div
        class="mode-switch-box"
        @click="switchDataViewMode">
        <icon-svg
          size="18"
          icon-class="icon-liebiaoshitu1" />
      </div>
    </div>
    <div class="custom-collapse-box">
      <div
        class="spin-box"
        v-if="isLoading">
        <Spin
          :pointNum="8"
          :translateX="25"
          background="var(--base-primary-bgColor)" />
      </div>
      <div
        class="collapse-item-box"
        v-if="!isLoading && unAddDataSets.length">
        <div
          class="title-box"
          @click="toggleCollapseVisible('unAdd')">
          <div
            :class="`icon-box ${
              isCollapseItemVisible('unAdd') ? 'is-active' : ''
            } `">
            <i class="el-icon-caret-right" />
          </div>
          <div class="dialog-label">未添加</div>
        </div>
        <div
          class="content-box"
          v-if="isCollapseItemVisible('unAdd')">
          <div class="dataset-list-box">
            <div
              class="dataset-item-box"
              v-for="(item, index) in unAddDataSets"
              :key="index">
              <div class="thumbnail-box">
                <img
                  v-if="item.thumbnail"
                  :src="`${imageBaseUrl}/${item.thumbnail}`" />
                <img
                  v-else
                  src="@/assets/img/default-scene-thumbnail.png" />
                <div class="mask-box">
                  <div
                    class="icon-box"
                    @click="addToScene(item)"
                    v-if="!tempAddedDataSet.includes(item.nodeId)">
                    <icon-svg
                      icon-class="icon-tianjiagoujian"
                      size="18"
                      class="icon" />
                  </div>
                </div>
                <div
                  class="checked-icon-box"
                  v-if="tempAddedDataSet.includes(item.nodeId)">
                  <icon-svg icon-class="icon-duihao" />
                </div>
              </div>
              <div
                class="name-box"
                :title="item.nodeName">
                <div class="name muti-line-text-overflow">
                  {{ item.nodeName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="collapse-item-box"
        v-if="!isLoading && addedDataSets.length">
        <div
          class="title-box"
          @click="toggleCollapseVisible('added')">
          <div
            :class="`icon-box ${
              isCollapseItemVisible('added') ? 'is-active' : ''
            } `">
            <i class="el-icon-caret-right" />
          </div>
          <div>已添加</div>
        </div>
        <div
          class="content-box"
          v-if="isCollapseItemVisible('added')">
          <div class="dataset-list-box">
            <div
              class="dataset-item-box"
              v-for="(item, index) in addedDataSets"
              :key="index">
              <div class="thumbnail-box">
                <img
                  v-if="item.thumbnail"
                  :src="`${imageBaseUrl}/${item.thumbnail}`" />
                <img
                  v-else
                  src="@/assets/img/default-scene-thumbnail.png" />
              </div>
              <div
                class="name-box"
                :title="item.nodeName">
                <div class="name muti-line-text-overflow">
                  {{ item.nodeName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="common-empty-box"
        v-if="!isLoading && isEmpty()">
        <bj-empty class="empty-page">
          <template slot="description">
            <div class="text-box empty-text">抱歉，没有找到相关内容</div>
          </template>
        </bj-empty>
      </div>
    </div>
  </div>
</template>

<script>
import Spin from '@/components/Spin.vue'

import {
  getBimTreeService,
  getSceneBimTreeService,
  getRsTreeService,
  getSceneRsTreeService,
  getWmtsTreeService,
  getSceneWmtsTreeService,
  getOsgbTreeService,
  getSceneOsgbTreeService,
  getPointCloudTreeService,
  getScenePointCloudTreeService,
  getCadTreeService,
  getSceneCadTreeService,
  getVectorTreeService,
  getSceneVectorTreeService,
  addDataSetToSceneService
} from '@/service/interface'

const dataSetTypeList = [
  {
    value: 'Bim',
    label: 'BIM模型',
    dataSetType: 0
  },
  {
    value: 'Rs',
    label: '遥感影像',
    dataSetType: 13
  },
  {
    value: 'Wmts',
    label: 'wmts服务',
    dataSetType: 10
  },
  {
    value: 'Osgb',
    label: '倾斜摄影',
    dataSetType: 11
  },
  {
    value: 'PointCloud',
    label: '点云数据',
    dataSetType: 15
  },
  {
    value: 'Cad',
    label: '二维图纸',
    dataSetType: 16
  },
  {
    value: 'Vector',
    label: '矢量数据',
    dataSetType: 20
  }
]

export default {
  data() {
    return {
      imageBaseUrl: window.imageBaseUrl,

      keywords: '',
      catalogTreeData: [],
      defaultProps: {
        children: 'subNodes',
        label: 'nodeName'
      },
      selectedNode: {},
      unCollapseItems: ['unAdd', 'added'],

      isLoading: false,
      unAddDataSets: [],
      loadingDataSets: [],
      addedDataSets: [],

      // 在未添加列表中，但实际已经加入场景中的数据集
      tempAddedDataSet: []
    }
  },
  props: {
    schemeType: String,
    currDataSetFolder: Object,
    isModelGroup: Boolean,
    switchDataViewMode: Function,
    updateScene: Function,
    updateSceneVector: Function,
    updateStatisticInfo: Function
  },
  components: {
    Spin
  },
  created() {
    this.initData()
  },
  watch: {
    schemeType: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.keywords = ''
        this.initData()
      }
    }
  },
  methods: {
    initData() {
      this.isLoading = true

      this.initCatalogTreeData().then(() => {
        this.queryDataSetList().then(dataSetList => {
          let find = dataSetTypeList.find(el => el.value === this.schemeType)
          dataSetList.forEach(item => {
            item.dataSetType = find.dataSetType
            item.srcDataSetType = find.dataSetType
            item.dataSetId = item.nodeId
          })

          this.unAddDataSets = dataSetList.filter(el => !el.isSelected)
          this.addedDataSets = dataSetList.filter(el => el.isSelected)
          this.tempAddedDataSet = []

          this.isLoading = false

          this.updateStatisticResult()
        })
      })
    },
    initCatalogTreeData() {
      return new Promise(resolve => {
        this.queryCatalogTreeData().then(catalogTreeData => {
          this.catalogTreeData = catalogTreeData
          if (catalogTreeData.length) {
            this.selectedNode = catalogTreeData[0]
          } else {
            this.selectedNode = {}
          }
          resolve()
        })
      })
    },
    handleNodeClick(nodeData) {
      this.selectedNode = nodeData
      this.queryDataSetList().then(dataSetList => {
        let find = dataSetTypeList.find(el => el.value === this.schemeType)
        dataSetList.forEach(item => {
          item.dataSetType = find.dataSetType
          item.srcDataSetType = find.dataSetType
          item.dataSetId = item.nodeId
        })

        this.unAddDataSets = dataSetList.filter(el => !el.isSelected)
        this.addedDataSets = dataSetList.filter(el => el.isSelected)
        this.tempAddedDataSet = []

        this.updateStatisticResult(true)
      })

      this.$refs.treeSelect.visible = false
    },
    search() {
      this.isLoading = true
      this.queryDataSetList().then(dataSetList => {
        let find = dataSetTypeList.find(el => el.value === this.schemeType)
        dataSetList.forEach(item => {
          item.dataSetType = find.dataSetType
          item.srcDataSetType = find.dataSetType
          item.dataSetId = item.nodeId
        })

        this.unAddDataSets = dataSetList.filter(el => !el.isSelected)
        this.addedDataSets = dataSetList.filter(el => el.isSelected)
        this.tempAddedDataSet = []

        this.isLoading = false

        this.updateStatisticResult(true)
      })
    },
    updateData() {
      this.queryDataSetList().then(dataSetList => {
        let find = dataSetTypeList.find(el => el.value === this.schemeType)
        dataSetList.forEach(item => {
          item.dataSetType = find.dataSetType
          item.srcDataSetType = find.dataSetType
          item.dataSetId = item.nodeId

          let findIndex = this.tempAddedDataSet.findIndex(
            el => item.nodeId === el && !item.isSelected
          )
          if (findIndex !== -1) {
            this.tempAddedDataSet.splice(findIndex, 1)
          }
        })

        this.unAddDataSets = dataSetList.filter(el => {
          if (!el.isSelected || this.tempAddedDataSet.includes(el.nodeId)) {
            return true
          } else {
            return false
          }
        })
        this.addedDataSets = dataSetList.filter(el => {
          if (el.isSelected) {
            if (!this.tempAddedDataSet.includes(el.nodeId)) {
              return true
            } else {
              return false
            }
          } else {
            return false
          }
        })

        this.updateStatisticResult()
      })
    },
    addToScene(dataSetInfo) {
      let startInterval = setInterval(() => {
        this.disabled = false
        clearInterval(startInterval)
      }, 60000)

      if (!this.disabled) {
        this.disabled = true
        // 需要转换后才能添加到场景的数据集类型
        const isNeedConvertDataSetType = [16, 20]

        let sceneId = this.$route.query.sceneId

        let parentId = this.getParentNodeId()
        let params = {
          sceneId,
          dataSets: [
            {
              parentId,
              dataSetId: dataSetInfo.nodeId,
              dataSetType: dataSetInfo.dataSetType
            }
          ]
        }
        addDataSetToSceneService(params).then(response => {
          if (response.isSuccess) {
            this.disabled = false
            if (isNeedConvertDataSetType.includes(dataSetInfo.dataSetType)) {
              let dataSetType = dataSetInfo.dataSetType === 16 ? 21 : 22
              setTimeout(() => this.updateSceneVector(dataSetType), 500)
            } else {
              this.updateScene([dataSetInfo])
            }

            let find = this.tempAddedDataSet.find(
              el => el === dataSetInfo.nodeId
            )
            if (!find) {
              this.tempAddedDataSet.push(dataSetInfo.nodeId)
            }

            this.updateStatisticResult()
          } else {
            this.disabled = false
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    getParentNodeId() {
      let currDataSetFolder = this.currDataSetFolder
      let parentNodeId = undefined
      if (currDataSetFolder.schemeType === this.schemeType) {
        parentNodeId = currDataSetFolder.nodeId
      }
      return parentNodeId
    },
    toggleCollapseVisible(collapseItem) {
      let findIndex = this.unCollapseItems.findIndex(el => el === collapseItem)
      if (findIndex !== -1) {
        this.unCollapseItems.splice(findIndex, 1)
      } else {
        this.unCollapseItems.push(collapseItem)
      }
    },
    isCollapseItemVisible(collapseItem) {
      let find = this.unCollapseItems.find(el => el === collapseItem)
      if (find) {
        return true
      } else {
        return false
      }
    },
    updateStatisticResult(isSearch) {
      let total = this.unAddDataSets.length + this.addedDataSets.length
      let addTotal = this.addedDataSets.length + this.tempAddedDataSet.length
      let dataSetTypeName = this.getDataSetTypeName()
      let info = ''
      if (isSearch || this.keywords) {
        info = `搜索到${dataSetTypeName}${total}个，其中已加入的有${addTotal}个`
      } else {
        info = `${dataSetTypeName}总共${total}个，场景中已加入${addTotal}个`
      }

      this.updateStatisticInfo(info)
    },
    getDataSetTypeName() {
      let dataSetType = dataSetTypeList.find(el => el.value === this.schemeType)
      if (dataSetType.value === 'Bim') {
        if (this.isModelGroup) {
          return '模型组'
        } else {
          return '模型'
        }
      } else {
        return dataSetType.label
      }
    },
    isEmpty() {
      return !this.unAddDataSets.length && !this.addedDataSets.length
    },
    queryCatalogTreeData() {
      return new Promise(resolve => {
        let schemeType = this.schemeType
        let projId = this.$route.params.projId
        let catalogTreeData = []
        switch (schemeType) {
          case 'Bim':
            getBimTreeService({ projId }).then(response => {
              if (response.isSuccess) {
                let data = response.data
                data = data.subNodes
                if (this.isModelGroup) {
                  catalogTreeData = data.filter(el => el.formatType === 2)
                  catalogTreeData[0].nodeName = '全部'
                } else {
                  catalogTreeData = data.filter(el => el.formatType === 1)
                  catalogTreeData[0].nodeName = '全部'
                }
                resolve(catalogTreeData)
              }
            })
            break
          case 'Osgb':
            getOsgbTreeService({ projId }).then(response => {
              if (response.isSuccess) {
                let data = response.data
                let catalogTreeData = [data]
                resolve(catalogTreeData)
              }
            })
            break
          case 'PointCloud':
            getPointCloudTreeService({ projId }).then(response => {
              if (response.isSuccess) {
                let data = response.data
                let catalogTreeData = [data]
                resolve(catalogTreeData)
              }
            })
            break
          case 'Rs':
            getRsTreeService({ projId }).then(response => {
              if (response.isSuccess) {
                let data = response.data
                let catalogTreeData = [data]
                resolve(catalogTreeData)
              }
            })
            break
          case 'Wmts':
            getWmtsTreeService({ projId }).then(response => {
              if (response.isSuccess) {
                let data = response.data
                let catalogTreeData = [data]
                resolve(catalogTreeData)
              }
            })
            break
          case 'Vector':
            getVectorTreeService({ projId }).then(response => {
              if (response.isSuccess) {
                let data = response.data
                let catalogTreeData = [data]
                resolve(catalogTreeData)
              }
            })
            break
          case 'Cad':
            getCadTreeService({ projId }).then(response => {
              if (response.isSuccess) {
                let data = response.data
                let catalogTreeData = [data]
                resolve(catalogTreeData)
              }
            })
            break
        }
      })
    },
    queryDataSetList() {
      return new Promise(resolve => {
        let schemeType = this.schemeType
        let sceneId = this.$route.query.sceneId
        let parentId = this.selectedNode.nodeId
        let params = { sceneId, parentId, dataSetName: this.keywords }
        switch (schemeType) {
          case 'Bim': {
            getSceneBimTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  data = data.subNodes
                  let dataSetList = []
                  if (this.isModelGroup) {
                    dataSetList = data.filter(el => el.formatType === 2)
                  } else {
                    dataSetList = data.filter(el => el.formatType === 1)
                  }
                  dataSetList = this.findAllNodeByLevel(dataSetList, 2)
                  resolve(dataSetList)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
          case 'Osgb': {
            getSceneOsgbTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  data = data.subNodes
                  let dataSetList = this.findAllNodeByLevel(data, 2)
                  resolve(dataSetList)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
          case 'PointCloud': {
            getScenePointCloudTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  data = data.subNodes
                  let dataSetList = this.findAllNodeByLevel(data, 2)
                  resolve(dataSetList)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
          case 'Rs': {
            getSceneRsTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  data = data.subNodes
                  let dataSetList = this.findAllNodeByLevel(data, 2)
                  resolve(dataSetList)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
          case 'Wmts': {
            getSceneWmtsTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  data = data.subNodes
                  let dataSetList = this.findAllNodeByLevel(data, 2)
                  resolve(dataSetList)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
          case 'Vector': {
            getSceneVectorTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  data = data.subNodes
                  let dataSetList = this.findAllNodeByLevel(data, 2)
                  resolve(dataSetList)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
          case 'Cad': {
            getSceneCadTreeService(params).then(response => {
              if (response.isSuccess) {
                let data = response.data
                if (data) {
                  data = data.subNodes
                  let dataSetList = this.findAllNodeByLevel(data, 2)
                  resolve(dataSetList)
                } else {
                  resolve([])
                }
              } else {
                this.$message.error(response.errMsg)
              }
            })
            break
          }
        }
      })
    },
    findAllNodeByLevel(data, level) {
      const array = []

      const traverse = item => {
        if (item.nodeType === level) {
          array.push(item)
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach(subNode => {
            traverse(subNode)
          })
        }
      }

      data.forEach(item => {
        traverse(item)
      })

      return array
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.dataset-card-list-box {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;

  .filter-box {
    display: flex;
    margin: 10px 0px;
    margin-top: 0;

    .common-input-box {
      width: 42%;
      flex-shrink: 0;
    }

    .select-box {
      flex-grow: 1;
      margin-right: 10px;

      :deep(.primary-select-custom) {
        min-width: 311px !important;

        .primary-select-option {
          height: 100%;
          padding: 0;

          &:hover {
            background: transparent;
          }
        }
      }
    }

    .mode-switch-box {
      margin-left: 10px;
      line-height: 32px;
      cursor: pointer;
      display: flex;
      align-items: center;
      &:hover {
        color: var(--base-primary-color);
      }
    }
  }

  .custom-collapse-box {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 0;
    overflow-y: auto;

    .spin-box {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .collapse-item-box {
      .title-box {
        display: flex;
        cursor: pointer;
        background: transparent;

        .icon-box {
          margin-right: 5px;
          color: var(--tabs-item-icon-color);
        }

        .is-active {
          transform: rotate(90deg);
        }
      }

      .content-box {
        .dataset-list-box {
          display: flex;
          flex-wrap: wrap;
          overflow-y: auto;
          margin-top: 12px;

          .dataset-item-box {
            width: 100px;
            margin-right: 6px;
            margin-bottom: 10px;
            padding: 8px;
            background-color: var(--sceneCard-BIM-item-bgColor);
            border-radius: 6px;
            border: 1px solid var(--sceneCard-BIM-item-border-color);

            &:nth-child(3n) {
              margin-right: 0px;
            }

            .thumbnail-box {
              position: relative;
              cursor: pointer;
              width: 84px;
              height: 54px;

              .checked-icon-box {
                display: flex;
                align-items: center;
                justify-content: center;
              }

              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 4px;
              }

              .mask-box {
                display: none;
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
                background: var(--base-bg-dark-color7);
                border-radius: 4px;

                .icon-box {
                  display: flex;
                  width: 26px;
                  height: 26px;
                  margin: auto;
                  border-radius: 5px;
                  color: var(--aside-bg-color);
                  background: var(--base-bg-light-color58);
                  font-size: 16px;

                  .icon {
                    margin: auto;
                  }
                }
              }

              .checked-icon-box {
                position: absolute;
                right: 0px;
                top: 0px;
                width: 20px;
                height: 20px;
                color: #07b500;
                font-size: 13px;
                border-radius: 1px;
                background: #cdf0cc;
                text-align: center;
              }

              &:hover {
                .mask-box {
                  display: flex;
                }
              }
            }

            .name-box {
              display: flex;
              align-items: center;
              margin-top: 4px;
              width: 100%;
              flex-wrap: wrap;

              .name {
                font-size: 12px;
                -webkit-line-clamp: 2;
                color: var(--default-color);
                text-align: left;
                word-break: break-all;
                white-space: wrap;
              }
            }
          }
        }
      }
    }

    .common-empty-box {
      .empty-page {
        :deep(.el-empty__image) {
          img {
            width: 80%;
            height: 80%;
          }
        }
      }

      .text-box {
        margin: auto;
        color: #909399;
        font-size: 14px;
      }
    }
  }
}
</style>
